import React from 'react';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import styles from './GoalHierarchyForm.module.scss';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import UnfoldLessOutlinedIcon from '@mui/icons-material/UnfoldLessOutlined';
import UnfoldMoreOutlinedIcon from '@mui/icons-material/UnfoldMoreOutlined';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import GroupRemoveIcon from '@mui/icons-material/GroupRemove';
import CropFreeIcon from '@mui/icons-material/CropFree';
import useTreeEditor from '../../../../../../hooks/useTreeEditor';
import useAuth from '../../../../../../hooks/useAuth';

export default function GoalHierarchyForm() {
  const { groups } = useAuth();
  const { isExpanded, setIsExpanded, filter, updateFilter } = useTreeEditor();
  return (
    <div className={styles.goalHierarchyForm}>
      {groups.includes('administrators') && (
        <Button
          component={Link}
          to={'edit'}
          variant="outlined"
          sx={{ background: '#ffffff' }}
          startIcon={<EditOutlinedIcon />}
        >
          Edit Goal Hierarchy
        </Button>
      )}
      <Button
        onClick={() => setIsExpanded((current) => !current)}
        variant="outlined"
        sx={{ background: '#ffffff' }}
        startIcon={isExpanded ? <UnfoldLessOutlinedIcon /> : <UnfoldMoreOutlinedIcon />}
      >
        {isExpanded ? 'Condense view' : 'Expand view'}
      </Button>
      <Button
        onClick={() => updateFilter({ displayTeamGoals: !filter?.displayTeamGoals })}
        variant={filter?.displayTeamGoals ? 'outlined' : 'contained'}
        sx={filter?.displayTeamGoals ? { background: '#ffffff' } : {}}
        startIcon={filter?.displayTeamGoals ? <GroupRemoveIcon /> : <GroupAddIcon />}
      >
        {`${filter?.displayTeamGoals ? 'Hide' : 'Show'} Team Goals`}
      </Button>
      {filter?.focusedNode !== null && (
        <Button
          onClick={() => updateFilter({ focusedNode: null })}
          variant="contained"
          // sx={{ background: '#ffffff' }}
          startIcon={<CropFreeIcon />}
        >
          Show Entire Hierarchy
        </Button>
      )}
    </div>
  );
}
